export const USER_DATA = {
	COOKIE_CODE: "citrus_order_user_data"
}

let debouncedCheckByPhone = BX.Runtime.debounce((phone, self) => {
	// check user agreements by phone

	BX.ajax.runAction('citrus:custom.Api.checkAgreementByPhone', {
		data: {
			phone: phone,
		}
	}).then(function (result) {
		if (result.data.user)
		{
			self.agreementChecked = result.data.user;
			self.subscriptionChecked = result.data.result;

			self.agreementShow = !result.data.user;
			self.subscriptionShow = !result.data.result;
		}
		else
		{
			self.agreementChecked = false;
			self.subscriptionChecked = false;

			self.subscriptionShow = true;
			self.agreementShow = true;
		}
	});
}, 500);

let userDataMixin = {

	data() {
		return {
			userData: {
				ORDER_PROP: {},
				ORDER_DESCRIPTION: "",
				PAY_SYSTEM_ID: "",
			},
			cookieCode: USER_DATA.COOKIE_CODE
		}
	},
	methods: {
		/** Инициализация. Собирает текущие данные для сохраения в куки */
		__initUserData() {
			this.cookieCode = this.params.hasOwnProperty('USER_DATA_COOKIE_CODE') ? this.params.USER_DATA_COOKIE_CODE : USER_DATA.COOKIE_CODE;

			/** Соберем текущие данные для сохраения в куки */
			for (let gIndex in this.propertyList) {
				let gProperty = this.propertyList[gIndex];
				for (let itemProperty of gProperty.items) {
					this.userData.ORDER_PROP[itemProperty.hasOwnProperty('PROPERTY_ID') ? itemProperty.PROPERTY_ID : itemProperty.ID] = itemProperty.VALUE;
				}
			}

			this.userData.ORDER_DESCRIPTION = this.comment.VALUE;

			for (let paysystem of this.result.PAY_SYSTEM) {
				if (paysystem.CHECKED == "Y") {
					this.userData.PAY_SYSTEM_ID = paysystem.ID;
					break;
				}
			}

			this.saveUserData();
		},
		/**
		 * Добавить измененное значение свойства заказа в текущие данные и Сохранить их в куки
		 *
		 * @param code
		 * @param value
		 */
		changePropertyUserData(code, value, checkByPhone) {
			this.userData["ORDER_PROP"][code] = value;

			checkByPhone = checkByPhone || false;
			if (checkByPhone)
			{
				debouncedCheckByPhone(value, this);

				if(value.length > 17 && this.result['COUPON_LIST'].length > 0) {
					window.location.reload();
				}
			}

			this.saveUserData();
		},

		/**
		 * Добавить измененное значение в текущие данные и Сохранить их в куки
		 *
		 * @param code
		 * @param value
		 */
		changeUserData(code, value) {
			this.userData[code] = value;

			this.saveUserData();
		},
		/**
		 * Сохранить текущие данные в куки
		 */
		saveUserData() {
			let encoded = btoa(encodeURIComponent(JSON.stringify(this.userData)));
			BX.setCookie(this.cookieCode, encoded, {path: BX.message("SITE_DIR")});
		},
		/**
		 * Получить текущие данные из кук
		 *
		 * @returns {any}
		 */
		getSavedUserData() {
			return JSON.parse(decodeURIComponent(atob(BX.getCookie(this.cookieCode))));
		},
		clearSavedUserData() {
			BX.setCookie(this.cookieCode, "", {path: BX.message("SITE_DIR"), expires: -1});
		}
	}
}

export {userDataMixin};

export default userDataMixin;
